/*
 * File: input-cron.ts
 * File Created: 2024-03-08 01:40:10
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 09:28:11
 * Modified By: Val Liu
 * -----
 */

import { Component, Emit, Prop } from "vue-property-decorator";
import { BaseInputComponent } from "../core/lib";
import { PropInnateSync } from "@root/core/vue-props";
import { IInputCronClassicData } from "./lib/cron-classic.vue";

@Component
export default class InputCron extends BaseInputComponent {
    @PropInnateSync("value", { type: String, default: undefined })
    innateValue!: string | undefined;

    @Prop({ type: String, default: "w_InputCronPlaceholder" })
    declare placeholder: string;

    @Prop({ type: Object, required: false })
    declare data: IInputCronClassicData;

    @Emit("text")
    doText(value) {
        this.text = value;
        return value;
    }

    /// private helpers
    cronPopover = false;
    text: string | null = null;
}
